import {Button} from 'antd';
import React, {useEffect} from 'react';
import {BrowserRouter, Routes, Route} from "react-router-dom";
import './static/iconfont/iconfont.css'

const Pages = React.lazy(() => import('./page/index'));


function App() {
    useEffect(() => {
            document.title = process.env.REACT_APP_TITLE;
    });
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route>
                        <Route path="/property/v1/*" element={<Pages/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
